import { Box, Card, Stack, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import CasinoMenu from './CasinoMenu';
import { useTranslation } from 'react-i18next';
import PinElement from '../../../components/material-ui/PinElement';
import { useEventListener, useLocalStorage } from 'usehooks-ts';
import useBootstrapSize from '../../../hooks/useBootstrapSize';
import { ENUM_LOCALSTORAGE } from '../../../enums/enums';

export default function SettingMenuCasino({ casinoListRef, casinoName, selectCasino }) {
  const { t } = useTranslation();
  const { isMobile } = useBootstrapSize();
  const [pined, setPined] = useLocalStorage(ENUM_LOCALSTORAGE.pinCasinoParam, false);
  const [isActivePin, setActivePin] = useState(false);

  const menuRef = useRef();
  const menuContainerRef = useRef();
  const menuContentRef = useRef();

  useEventListener('scroll', () => {
    if (!menuRef.current) return;
    if (!pined) return;
    if (isMobile) return;

    if (casinoListRef.current?.offsetHeight <= menuContentRef.current?.offsetHeight) {
      return;
    }

    const rect = menuContainerRef.current.getBoundingClientRect();
    const currentTopOffset = rect.top;
    setActivePin(currentTopOffset <= 0);
  });

  const sxOrdinary = {
    height: '100%',
    position: 'relative'
  };

  const sxWhenPin = {
    position: 'fixed',
    top: '12px',
    width: menuContainerRef.current?.offsetWidth || 'auto',
    height: '100%',
    maxHeight: 'calc(100svh - 24px)',
    overflow: 'auto',
    paddingBottom: 5
  };

  return (
    <Box height={'100%'} ref={menuContainerRef}>
      <Card
        ref={menuRef}
        variant={'outlined'}
        sx={isActivePin && !isMobile ? sxWhenPin : sxOrdinary}>
        <Stack gap={0} ref={menuContentRef}>
          <ShowContainer condition={casinoName}>
            <ShowContainer condition={!isMobile}>
              <Box sx={{ position: 'absolute', top: 0, right: 0 }}>
                <PinElement pined={pined} setPined={setPined} />
              </Box>
            </ShowContainer>

            <Typography variant="body1" fontWeight={600} mb={1}>
              {t('Casino parameters')} "{casinoName}"
            </Typography>
          </ShowContainer>
          <CasinoMenu casinoId={selectCasino} selectCasino={selectCasino} isDelete />
        </Stack>
      </Card>
    </Box>
  );
}
